import { render, staticRenderFns } from "./AssignmentDetailView.vue?vue&type=template&id=7447a8c0&scoped=true&"
import script from "./AssignmentDetailView.vue?vue&type=script&lang=ts&"
export * from "./AssignmentDetailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7447a8c0",
  null
  
)

export default component.exports